<template>
  <div>
    <el-table :data="records">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="mortgageAmount" label="抵押金额">
        <template slot-scope="scope">
          {{ scope.row.mortgageAmount }} {{ scope.row.mortgageCoinType }}
        </template>
      </el-table-column>
      <el-table-column prop="mortgageAmount" label="抵押金额">
        <template slot-scope="scope">
          {{ scope.row.borrowAmount }} {{ scope.row.borrowCoinType }}
        </template>
      </el-table-column>
      <el-table-column
        prop="borrowingMortgageScale"
        label="借贷比例"
      ></el-table-column>
      <el-table-column prop="burstScale" label="爆仓比例"></el-table-column>
      <el-table-column prop="warnScale" label="警告比例"></el-table-column>
      <el-table-column prop="interest" label="已产生利息"></el-table-column>
      <el-table-column prop="numberDays" label="周期"></el-table-column>
      <el-table-column prop="overdueRate" label="逾期利率"></el-table-column>
      <el-table-column prop="defaultRate" label="违约利率"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">借贷中</span>
          <span v-else-if="scope.row.status == 2">已到期</span>
          <span v-else-if="scope.row.status == 3">已逾期</span>
          <span v-else-if="scope.row.status == 4">违约还款</span>
          <span v-else-if="scope.row.status == 5">逾期还款</span>
          <span v-else-if="scope.row.status == 11">已还款</span>
          <span v-else-if="scope.row.status == 12">爆仓</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'corocord',
  computed: {
    ...mapState('mortgagerecord', [
      'totalCount',
      'pagination',
      'rata',
      'records'
    ])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('mortgagerecord', ['getRecords']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
